// ================================================================================
// gsap.js
// gsap 用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// TOP ページ専用
	// --------------------------------------------------------------- //

	gsap.to('.js-front-copy', {
		y: 0,
		autoAlpha: 1,
		stagger: 0.1,
		delay: 0.5,
		duration: 0.6,
		ease: 'power1.out',
	});



	// TOP サークルアニメーション
	// --------------------------------------------------------------- //

	gsap.fromTo('.js-front-mission-background', {
		scale: 0,
	}, {
		scrollTrigger: {
			trigger: ".front-mission",
			start: "top center",
		},
		scale: 1,
	});



	// タイトルアニメーション
	// --------------------------------------------------------------- //

	const scrollAnimeTitles = gsap.utils.toArray('.js-title-animation-cover');
	scrollAnimeTitles.forEach((scrollAnimeTitle) => {
		gsap.fromTo(
			scrollAnimeTitle,
			{
				x: 0,
			},
			{
				x: '100%',
				scrollTrigger: {
					trigger: scrollAnimeTitle,
					start: "top-=150px center",
				},
				duration: 2.5,
			}
		);
	});



	// スクロールアニメーション
	// --------------------------------------------------------------- //

	const scrollAnimeElmnts = gsap.utils.toArray('.js-scroll-animation');
	scrollAnimeElmnts.forEach((scrollAnimeElmnt) => {
		gsap.fromTo(
			scrollAnimeElmnt,
			{
				y: 50,
				autoAlpha: 0,
			},
			{
				y: 0,
				autoAlpha: 1,
				scrollTrigger: {
					trigger: scrollAnimeElmnt,
					start: "top-=150px center",
				},
			}
		);
	});


} );


